import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';
import { DataLayerItemType } from '../api/dataLayer.model';
import {
  getDataLayerItemTypeIcon,
  getDataLayerItemTypeDisplayName,
  SUPPORTED_FILE_EXTENSIONS,
  getFileExtensionIcon,
  getFileExtensionDisplayName,
} from 'src/app/common/dataLayer/dataLayerUtils';

// Prefix for file extension options to distinguish from type options
export const FILE_EXTENSION_VALUE_PREFIX = 'file_ext:';

// Helper to check if a value is a file extension filter
export function isFileExtensionValue(value: string): boolean {
  return value.startsWith(FILE_EXTENSION_VALUE_PREFIX);
}

// Helper to extract the actual file extension from the value
export function extractFileExtension(value: string): string {
  return value.replace(FILE_EXTENSION_VALUE_PREFIX, '');
}

// Type options (email, website, and messages - file type is handled via file extensions)
const typeOptions: ISelectOption[] = [
  DataLayerItemType.email,
  DataLayerItemType.website,
  DataLayerItemType.messages,
].map((type) => ({
  id: `${FilterTypesEnum.DataType}-${type}`,
  value: type,
  displayName: getDataLayerItemTypeDisplayName(type),
  withoutBeautifyDisplayName: true,
  filterType: FilterTypesEnum.DataType,
  categoryName: FilterTypesEnum.DataType.toString(),
  iconPath: getDataLayerItemTypeIcon(type),
}));

// File extension options
const fileExtensionOptions: ISelectOption[] = SUPPORTED_FILE_EXTENSIONS.map((ext) => ({
  id: `${FilterTypesEnum.DataType}-${FILE_EXTENSION_VALUE_PREFIX}${ext}`,
  value: `${FILE_EXTENSION_VALUE_PREFIX}${ext}`,
  displayName: getFileExtensionDisplayName(ext),
  withoutBeautifyDisplayName: true,
  filterType: FilterTypesEnum.DataType,
  categoryName: FilterTypesEnum.DataType.toString(),
  iconPath: getFileExtensionIcon(ext),
}));

// Combined options for the Data Type filter (types first, then file extensions sorted alphabetically)
export const DataLayerItemTypeSelectOptions: ISelectOption[] = [
  ...typeOptions,
  ...fileExtensionOptions.sort((a, b) => a.displayName.localeCompare(b.displayName)),
];
